<template>
  <div class="my-3">
    <b-row align-h="between">
      
      <!-- <div class="col">
        <b-pagination
        class=""
        v-model="objPaginacao.current_page"
        :total-rows="objPaginacao.total"
        :per-page="objPaginacao.per_page"
        first-text="<< Primeiro"
        prev-text="Anterior"
        next-text="Próximo"
        last-text="Último >>"
        @input="mudarPaginacao"
      /> 
      </div>-->

      <div class="col-10 display-flex">
        <div class="mr-2" v-if="exibirTotalRegistros">
            <SGPFormBotaoComponent
              :rounded="false"
              class="text-capitalize"
            >
              Total de registros {{ paginacaoAtual.total }}
            </SGPFormBotaoComponent>
        </div>

        <div v-if="botaoFiltrarDeletados">
          <SGPFormBotaoComponent
            :rounded="false"
            class="text-capitalize"
            :outlined="true"            
            tonal
            :color="`${filtrarDeletados ? 'primary' : 'grey darken-4'} text-white`"
            @click="filtrarDeletadosPaginacao"
          >
            <SGPIconComponent large class="mr-1" :color="`${filtrarDeletados ? 'primary' : 'blue-grey'}`">
              {{ filtrarDeletados ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}
            </SGPIconComponent>
            Filtrar Deletados
          </SGPFormBotaoComponent>
        </div>
      </div>

      <div class="col-2 text-right" v-if="exibirQtdeRegistros"> 
          <SGPFormSelectComponent 
              name="qtd_registros"
              :listaDeOptions="perPageOptions"
              v-model="objPaginacao.per_page"
              data-vv-as="Qtd Registros"
              optionLabel="text"
              optionValue="value"
              placeholder="Qtd Registros por página"
              @change="mudarPaginacaoSelect"
          />
      </div>
    </b-row>

    <slot></slot>    

    <div class="col">
      <b-pagination
        class=""
        v-model="paginacaoAtual.current_page"
        :total-rows="paginacaoAtual.total"
        :per-page="paginacaoAtual.per_page"
        first-text="<< Primeiro"
        prev-text="Anterior"
        next-text="Próximo"
        last-text="Último >>"
        @change="mudarPaginacao"
        :size="sizePaginacao"
      >
      </b-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SGPPaginacaoComponent',
  
  props: {
    paginacao: {
      type: Object,
      required: true
    },
    exibirTotalRegistros: {
      type: Boolean,
      required: false,
      default: true
    },
    exibirQtdeRegistros: {
      type: Boolean,
      required: false,
      default: true
    },
    sizePaginacao: {
      type: String,
      required: false,
      default: ''
    },

    botaoFiltrarDeletados: {
      type: Boolean,
      required: false,
      default: false
    },

    filtrarDeletados: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      objPaginacao: { ...this.paginacao },
      options: [
        { value: 20, text: '20' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 200, text: '200' },
        { value: 500, text: '500' },
        { value: 1000, text: '1000' },
        { value: 1500, text: '1500' },
        { value: 2000, text: '2000' },
        { value: this.paginacao.total, text: `Listar todos` },
      ]
    }
  },

  computed: {
    perPageOptions () {
      return this.options.filter(item => item.value <= this.paginacao.total )
    },
    paginacaoAtual () {
      return this.paginacao;
    },
  },

  emits: [
    'sgpAtualizarPaginacao',
    'sgpPaginacaoComponentFiltrarDeletados'
  ],


  methods: {
    mudarPaginacao (page) {
      this.objPaginacao.current_page = page
      this.$emit('sgpAtualizarPaginacao', this.objPaginacao)
    },

    mudarPaginacaoSelect () {
      this.objPaginacao.current_page = 1
      this.$emit('sgpAtualizarPaginacao', this.objPaginacao)
    },

    limparQtdPorPagina () {
      this.objPaginacao.per_page = "";
    },

    filtrarDeletadosPaginacao() {
      this.$emit('sgpPaginacaoComponentFiltrarDeletados', !this.filtrarDeletados)
    }
  }
}
</script>

<style lang="scss" scoped>
.display-flex {
  display: flex;
  align-items: center;
}
</style>